import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

export const FundsModelSchema = z
  .object({
    id: z.string(),
    // funds.name is NOT NULL
    name: z.string(),
    legal_name: z.string().nullish(),
    functional_currency_id: z.preprocess((val) => {
      if (val === null || val === undefined || typeof val !== 'string') return undefined
      const trimmed = val.trim()
      return trimmed === '' || trimmed === 'null' ? undefined : val
    }, z.string().optional()),
    pipeline_origination: z.preprocess((val) => {
      if (val === null || val === undefined || typeof val !== 'string') return undefined
      const trimmed = val.trim()
      return trimmed === '' || trimmed === 'null' ? undefined : val
    }, z.string().optional()),
    managed_by_us: z.boolean().optional(),
    // SBA Small Business Investment Company fund. The deal commit gate reads this
    // to decide whether to ask for a Critical Technology Area; nothing matches a
    // fund by name. Computed COALESCE(...,false) server-side, so never null.
    is_sbic: z.boolean().optional(),
    // Fund lifecycle (fund status, 2026-09-04). The ids carry the Tag; the two
    // booleans are computed once in get_global_configs_v3 so no picker
    // re-derives them, and both FAIL OPEN — an unclassified fund is active and
    // open. Deliberately no is_open/is_cancelled here: those belong to the
    // catalogue (globalConfigs.fund_statuses) and would go stale on this row
    // the moment an admin edited a status.
    fundraising_status_id: z.preprocess((val) => {
      if (val === null || val === undefined || typeof val !== 'string') return undefined
      const trimmed = val.trim()
      return trimmed === '' || trimmed === 'null' ? undefined : val
    }, z.string().optional()),
    investment_status_id: z.preprocess((val) => {
      if (val === null || val === undefined || typeof val !== 'string') return undefined
      const trimmed = val.trim()
      return trimmed === '' || trimmed === 'null' ? undefined : val
    }, z.string().optional()),
    is_active: z.boolean().optional(),
    is_fundraising_open: z.boolean().optional()
  })
  .strict()

export const FundsModelFields = makeFieldKeys(FundsModelSchema)

export type FundsModel = z.infer<typeof FundsModelSchema>

function validateFundsModel(data: unknown): FundsModel {
  try {
    return validateWithZodSchema(FundsModelSchema, data, 'funds model')
  } catch (error) {
    throw new Error(`Funds model validation failed: ${error}`)
  }
}
